import { GridColDef } from '@mui/x-data-grid';

import { renderCellFor, RTRAnalyticsWidget } from '../../helper';
import { IPostgreRTRDTO } from '../types';

export const getColumnsForRTR = (
  widgetName: RTRAnalyticsWidget,
  widgetData: IPostgreRTRDTO
): GridColDef[] => {
  const uniqueStatus = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.statusWithCount ?? '')))
  );
  switch (widgetName) {
    case RTRAnalyticsWidget.RTR_RECRUITER_TABLE:
      return [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 2,
          minWidth: 170,
          renderCell: (params) =>
            renderCellFor(
              'RECRUITER',
              params,
              params.row['recruiterName'] && params.row['recruiterName'] !== '__MISSING__'
                ? params.row['recruiterName']
                : params.row['recruiterEmail']
            ),
        },
        {
          field: 'count',
          headerName: `Total Count(${widgetData?.count ?? 0})`,
          flex: 1,
          minWidth: 150,
        },
        ...uniqueStatus.map((status) => ({
          field: status,
          headerName: status,
          width: 150,
        })),
      ];
    case RTRAnalyticsWidget.RTR_JOB_TITLE_TABLE:
      return [
        {
          field: 'jobTitle',
          headerName: 'Job Title',
          flex: 2,
          minWidth: 170,
          renderCell: (params) => renderCellFor('JOB', params),
        },
        {
          field: 'count',
          headerName: `Total Count(${widgetData?.count ?? 0})`,
          flex: 1,
          minWidth: 150,
        },
        ...uniqueStatus.map((status) => ({
          field: status,
          headerName: status,
          width: 150,
        })),
      ];
    default:
      throw new Error('Invalid table widget name');
  }
};

export function getTableDataForRTR(widgetName: RTRAnalyticsWidget, widgetData: IPostgreRTRDTO) {
  const uniqueStatus = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.statusWithCount ?? '')))
  );
  switch (widgetName) {
    case RTRAnalyticsWidget.RTR_RECRUITER_TABLE:
      widgetData?.resultSet?.forEach((record, index) => {
        record.id = index;
        uniqueStatus.forEach((status) => {
          record[status] = record?.statusWithCount?.[status] || 0;
        });
      });
      return widgetData?.resultSet;
    case RTRAnalyticsWidget.RTR_JOB_TITLE_TABLE:
      widgetData?.resultSet?.forEach((record, index) => {
        record.id = index;
        uniqueStatus.forEach((status) => {
          record[status] = record?.statusWithCount?.[status] || 0;
        });
      });
      return widgetData?.resultSet;
    default:
      return [];
  }
}
